export const LOCALE_CONFIG = {
  en: { pathPrefix: '', hreflang: 'en', isDefault: true },
  'pt-PT': { pathPrefix: '/pt-pt', hreflang: 'pt-PT', isDefault: false },
  es: { pathPrefix: '/es', hreflang: 'es', isDefault: false },
  de: { pathPrefix: '/de', hreflang: 'de', isDefault: false },
  fr: { pathPrefix: '/fr', hreflang: 'fr', isDefault: false },
} as const

export type LocaleCode = keyof typeof LOCALE_CONFIG

export const DEFAULT_LOCALE: LocaleCode = 'en'
export const SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG) as LocaleCode[]
export const PREFIXED_LOCALE_PATHS = Object.values(LOCALE_CONFIG)
  .map(config => config.pathPrefix)
  .filter(prefix => prefix !== '')

export const LOCALE_LABELS: Record<LocaleCode, string> = {
  en: 'English',
  'pt-PT': 'Portuguese (Portugal)',
  es: 'Spanish',
  de: 'German',
  fr: 'French',
}

export function isSupportedLocale(value: string): value is LocaleCode {
  return value in LOCALE_CONFIG
}

export function getLocalePathPrefix(locale: LocaleCode): string {
  return LOCALE_CONFIG[locale].pathPrefix
}

export function getLocaleHreflang(locale: LocaleCode): string {
  return LOCALE_CONFIG[locale].hreflang
}

export function getLocaleLabel(locale: LocaleCode): string {
  return LOCALE_LABELS[locale]
}
